import * as React from "react";
import BasePopup from "./BasePopup.jsx"
import {useRecoilState} from "recoil";
import {popupAtom} from "./popupAtom";

const AttributePopup = ({ data }) => {
  const [popup] = useRecoilState(popupAtom);

  let text = data.attributes
    .map((attribute) => data.properties[attribute])
    .join(": ");

    if (popup.layerId === "imd"){
        text = `IMD percentile: ${data.properties["imd19_per"]}`;
    }

  if (data.clickToSelect) {
    text = text.trim()
    const fullStop = !text || text.endsWith(".") ? '' : '.'
    text = `${text.trim()}${fullStop} Click to select this highstreet.`
  }

  return (
    <BasePopup coords={data.coords} closeButton={!data.clickToSelect}>
      <div style={{
        color: "black",
        fontSize: "14px",
        padding: "0 0.8rem 0.8rem 0.8rem"
      }}>
        {text}
      </div>
    </BasePopup>
  )
}

export default AttributePopup;